module.exports = __webpack_public_path__ + "media/brands/new-holland-2f9af462.png";